import { isLandingWorkspaceAction, type LandingWorkspaceAction } from "@/src/features/landing/workspaceActionState";

const LANDING_LOCALE_CONTINUITY_KEY = "smartmanager:landing-locale-continuity";

export type LandingLocaleContinuity = {
  activeAction: LandingWorkspaceAction | null;
};

function normalizeContinuity(value: unknown): LandingLocaleContinuity | null {
  if (!value || typeof value !== "object") return null;
  const candidate = value as { activeAction?: unknown };
  const stored = candidate.activeAction;
  // A retired window (About, Features) reopens nothing.
  const activeAction = typeof stored === "string" && isLandingWorkspaceAction(stored) ? stored : null;
  return { activeAction };
}

/** Stores only non-sensitive navigation state for the locale refresh remount. */
export function persistLandingLocaleContinuity(value: LandingLocaleContinuity): void {
  try {
    window.sessionStorage.setItem(LANDING_LOCALE_CONTINUITY_KEY, JSON.stringify(value));
  } catch {
    // Privacy modes may deny storage; locale switching must still work.
  }
}

/** Consumes the snapshot once so ordinary revisits still start with no window open. */
export function consumeLandingLocaleContinuity(): LandingLocaleContinuity | null {
  try {
    const raw = window.sessionStorage.getItem(LANDING_LOCALE_CONTINUITY_KEY);
    return raw ? normalizeContinuity(JSON.parse(raw)) : null;
  } catch {
    return null;
  }
}

/** Clears continuity only after the delayed workspace restoration commits. */
export function clearLandingLocaleContinuity(): void {
  try {
    window.sessionStorage.removeItem(LANDING_LOCALE_CONTINUITY_KEY);
  } catch {
    // Privacy modes may deny storage; there is nothing else to clear.
  }
}

export const __test__ = { normalizeContinuity };
